import onboardingHubMicroExperiment from 'features/Onboarding/lib/onboardingHubMicroExperiment';
import { ApplicantType, ApplicationType } from 'features/Onboarding/types';

import { VerificationModuleData } from '../../machine/model';
import getAgreementsStep from './getAgreementsStep';
import getBeneficiariesStep from './getBeneficiariesStep';
import { getCompanyCreationDocumentsStep } from './getCompanyCreationDocumentsStep';
import getCompanyFinancialInfoStep from './getCompanyFinancialInfoStep';
import getCompanyPapersStep from './getCompanyPapersStep';
import getComplianceAndPersonalAddressStep from './getComplianceAndPersonalAddressStep';
import getDraftStatutesStep from './getDraftStatutesStep';
import getIdentityStep from './getIdentityStep';
import getMandateStep from './getMandateStep';
import getPricingPlanStep from './getPricingPlanStep';
import getProofOfAddressStep from './getProofOfAddressStep';
import getProofOfFundsStep from './getProofOfFundsStep';
import getQesStep from './getQesStep';
import getShineStartVerificationStep from './getShineStartVerificationStep';
import getStatutesStep from './getStatutesStep';
import { VerificationStatus, VerificationStep } from './types';

const getVerificationSteps = (moduleData: VerificationModuleData) => {
  const { applicantType, applicationType, verificationData } = moduleData;
  const { isMicro } = verificationData.viewer.company.profile;

  const steps: VerificationStep[] = [];

  steps.push(
    getComplianceAndPersonalAddressStep(moduleData),
    getIdentityStep(moduleData),
    getQesStep(moduleData),
    getProofOfAddressStep(moduleData),
  );

  const isOnboardingHub =
    applicationType === ApplicationType.Standard &&
    applicantType === ApplicantType.AccountHolder;

  const isOnboardingHubMicroExp =
    onboardingHubMicroExperiment.getIsUserInExperiment(
      verificationData.viewer.profile,
    );

  // Micro companies still do company compliance step pre-hub
  if (isOnboardingHub) {
    const companyFinancialInfoStep = getCompanyFinancialInfoStep(moduleData);

    if (
      !isMicro ||
      isOnboardingHubMicroExp ||
      // Catch scenarios where the step was skipped pre-hub
      companyFinancialInfoStep.status === VerificationStatus.ToDo
    ) {
      steps.push(companyFinancialInfoStep);
    }
  }

  if (isOnboardingHub) {
    steps.push(getBeneficiariesStep(moduleData));
  }

  steps.push(
    getStatutesStep(moduleData),
    getCompanyPapersStep(moduleData),
    getDraftStatutesStep(moduleData),
    getProofOfFundsStep(moduleData),
    getMandateStep(moduleData),
    getShineStartVerificationStep(moduleData),
    getCompanyCreationDocumentsStep(moduleData),
  );

  if (isOnboardingHub && (!isMicro || isOnboardingHubMicroExp)) {
    steps.push(getPricingPlanStep(moduleData), getAgreementsStep(moduleData));
  }

  return steps.filter(
    ({ metadata, status }) =>
      status !== VerificationStatus.Irrelevant && !metadata.isHidden,
  );
};

export default getVerificationSteps;
